import * as actions from "../actions/utility-actions";
import { UtilityState } from "../store/UtilityState";

/**
 * The Utility Module Redux Reducer
 * @param state The IApplicationState for this reducer
 * @param action Standard Redux action payload of a type and payload 
 */
export function utilityReducer(state = new UtilityState(), action: IReduxAction) {
    switch (action.type) {
        case actions.UTILITY_SHOW_LOADING:
            return Object.assign({}, state, { isLoading: true });
        case actions.UTILITY_HIDE_LOADING:
            return Object.assign({}, state, { isLoading: false });
        case actions.UTILITY_SHOW_DOWNLOADING:
            return Object.assign({}, state, { isDownloading: true });
        case actions.UTILITY_HIDE_DOWNLOADING:
            return Object.assign({}, state, { isDownloading: false });
        case actions.UTILITY_SHOW_TOAST:
            return {
                ...state,
                toasts: [...state.toasts, action.payload]
            }
        case actions.UTILITY_HIDE_TOAST:
            return Object.assign({}, state, { isLoading: false });
        case actions.UTILITY_REMEMBER_SCROLL_POSITION: 
            const scrollToAddTo = { ...state.scrollState };
            const pos = {
                x: action.payload.x, 
                y: action.payload.y
            };
            
            scrollToAddTo[action.payload.subkey] = pos;

            return Object.assign({
                ...state,
                scrollState: scrollToAddTo
            }); 
        case actions.UTILITY_CLEAR_SCROLL_POSITION: {

            const scrollToRemoveFrom = { ...state.scrollState };
            scrollToRemoveFrom[action.payload.subkey] = undefined;

            return Object.assign({
                ...state,
                scrollState: scrollToRemoveFrom
            });
        }       
        case actions.UTILITY_NOTIFICATION_RESET: 
            return Object.assign({
                ...state,
                notifications: [...action.payload]
            });
        case actions.UTILITY_NOTIFICATION_ADD: 
            return Object.assign({
                ...state,
                notifications: [...state.notifications, action.payload]
            });
        case actions.UTILITY_NOTIFICATION_ACTIVATE:
            const listForAct = state.notifications;
            listForAct[action.payload].isInFlight = true;
            
            return Object.assign({
                ...state,
                notifications: [...listForAct]
            });
        case actions.UTILITY_NOTIFICATION_DEACTIVATE:
            const listForDeact = state.notifications;
            listForDeact[action.payload].isInFlight = false;

            return Object.assign({
                ...state,
                notifications: [...listForDeact]
            });
        case actions.SIGNALR_CONNECTED:
            return {
                ...state,
                signalRConnected: true
            };
        case actions.SIGNALR_UPDATE:
            return {
                ...state,
                notifications: [...state.notifications, action.payload]
            };
        default:
            return state;
    }
}
